import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUseCaseNotAFit = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 14,
			height: 14,
			rx: 2,
			fill: "#FF6363"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.66797 4.66797L9.33325 9.33325",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.33203 4.66797L4.66675 9.33325",
			stroke: "white",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgUseCaseNotAFit;
